'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoAndroidFavorite = function IoAndroidFavorite(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm19.8 35l-2.4-2.1c-8.4-7.7-13.9-12.7-13.9-18.9 0-5.1 3.9-9 8.9-9 2.8 0 5.6 1.3 7.4 3.4 1.7-2.1 4.5-3.4 7.3-3.4 5 0 8.9 3.9 8.9 9 0 6.2-5.5 11.2-13.9 18.9z' })
        )
    );
};

exports.default = IoAndroidFavorite;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/android-favorite.js
// module id = 2095
// module chunks = 0